// Module
var code = "<div class=\"container-fluid\">\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <h2>議会情報</h2>\n    </div>\n  </div>\n</div>\n";
// Exports
export default code;